import { graphql } from "@/gql";

export const createRelocationPageMutation = graphql(`
  mutation CreateRelocationPage($input: CreateRelocationPageInput!) {
    createRelocationPage(input: $input) {
      id
    }
  }
`);

export const updateRelocationPageMutation = graphql(`
  mutation UpdateRelocationPage($id: ID!, $input: UpdateRelocationPageInput!) {
    updateRelocationPage(id: $id, input: $input) {
      id
    }
  }
`);

export const deleteRelocationPageMutation = graphql(`
  mutation DeleteRelocationPage($id: ID!) {
    deleteRelocationPage(id: $id) {
      id
    }
  }
`);
